module.exports = __webpack_public_path__ + "802db2537941f3385fa2153cb33bddeb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-29.png
// module id = 3291
// module chunks = 0